import { Pipe, PipeTransform } from '@angular/core';
import { L10nService } from '../services/l10n.service';

@Pipe({
  name: 'dayOfWeek'
})
export class DayOfWeekPipe implements PipeTransform {

  constructor(private l10nService: L10nService) {
  }

  transform(dayOfWeek: any, args?: any): string {
    // 0-6, 0 represents Sunday
    if (dayOfWeek === undefined || dayOfWeek === null || dayOfWeek === '') {
      return '';
    }
    let dayOfWeekStartingWithMonday = parseInt(dayOfWeek, 10) - 1;
    if (dayOfWeekStartingWithMonday < 0) {
      dayOfWeekStartingWithMonday = 6;
    }
    return this.l10nService.get('dayOfWeek_' + dayOfWeekStartingWithMonday);
  }

}
